const useCarousel =
  () =>
  (index, slide, space = 0) => {
    const carouselSlider = document.querySelector(`${slide}`);
    if (!carouselSlider) return;

    const element = carouselSlider.children[0] || null;
    const size = element ? element.clientWidth : 0;

    const isRTL = String(document?.dir || document?.documentElement?.dir).toLowerCase() === 'rtl';

    carouselSlider.style.transition = 'transform 0.4s ease-in-out';
    const delta = (size + space) * index * (isRTL ? 1 : -1);
    carouselSlider.style.transform = `translateX(${delta}px)`;
  };

export default useCarousel;
